import { decorate, observable } from 'mobx';

class OverviewStore {

 }

 decorate(OverviewStore, {
    })
 export default OverviewStore;